<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <!-- TEXT INPUT -->
    <template v-slot:activator>
      <v-text-field
        v-model="picker"
        :rules="[timeRule]"
        placeholder="HH:mm"
        clearable
        @blur="validateTime"
      >
        <!-- ICON CLICK ONLY -->
        <template v-slot:prepend>
          <v-icon @click.stop="menu = true">
            mdi-clock
          </v-icon>
        </template>
      </v-text-field>
    </template>

    <!-- TIME PICKER -->
    <v-time-picker
      v-model="picker"
      format="24hr"
      @change="menu = false"
    />
  </v-menu>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      menu: false
    };
  },

  computed: {
    picker: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },

    timeRule() {
      return v =>
        !v ||
        /^([01]\d|2[0-3]):([0-5]\d)$/.test(v) ||
        "Geçerli saat gir (HH:mm)";
    }
  },

  methods: {
    validateTime() {
      const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;

      if (this.picker && !regex.test(this.picker)) {
        this.$emit("input", "");
      }
    }
  }
};
</script>
